import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

export type ProtocolType = 'HANDOVER' | 'RETURN'

interface UploadProtocolParams {
  flatId: string
  file: File
  protocolType: ProtocolType
}

export interface FlatProtocol {
  id: string
  name: string
  protocol_type: ProtocolType
  document: string
  created_at: string
}

export function useUploadProtocol() {
  const toast = useToast()
  const { t } = useTranslation('toast')
  const queryClient = useQueryClient()
  const onError = useOnError()

  async function uploadProtocol({ flatId, file, protocolType }: UploadProtocolParams) {
    const formData = new FormData()
    formData.append('document', file)
    formData.append('protocol_type', protocolType)

    const res = await apiClient.post<FlatProtocol>(
      `${SNA_PREFIX}flats/${flatId}/protocols`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    )

    return res.data
  }

  return useMutation({
    mutationFn: uploadProtocol,
    onSuccess: (_, variables) => {
      toast.success({ message: t('protocolUploaded') })
      queryClient.invalidateQueries({ queryKey: ['flat-protocols', variables.flatId] })
    },
    onError
  })
}
